module.exports = __webpack_public_path__ + "static/about-header-big.c4e6ca6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-header-big.jpg
// module id = 108
// module chunks = 253626871324061 263791100135453